<template>
  <div>
    <Breadcrumbs main="shifts" title="active shifts" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-xl-12 xl-100">
          <b-card header-tag="div" no-body>
            <h5 slot="header">New salaries</h5>
            <div slot="header">
              <div>Choose month</div>
              <div class="month">
                <b-form-select
                  @change="changeMonth"
                  :options="months"
                  v-model="selected"
                ></b-form-select>
              </div>
            </div>
            <b-card-body>
                <div v-if="!selected">   There are no records to show - please select month. </div>
                <div v-if="listItems && !listItems.length">No records to show in this month.</div>
              <b-tabs pills slot="header" class="tabbed-card" v-if="selected">
                <b-tab title="3z" active>
                  <div class="row">
                    <div
                      class="col-sm-6"
                      v-for="form in listItems"
                      :key="form.id"
                      @click="changeView(form.id)"
                    >
                      <px-card
                        class="bg-primary static-top-widget-card clickable"
                        v-if="listItems"
                      >
                        <div slot="with-padding">
                          <div class="media static-top-widget">
                            <div class="align-self-center text-center">
                              <feather
                                type="file-plus"
                                class="middle"
                              ></feather>
                            </div>
                            <div class="media-body">
                              <span class="m-0"
                                >{{ form.name }} |
                                <strong>{{ form.month }}</strong></span
                              >
                              <h6 class="m-0">
                                Do wypłaty: {{ form.doWyplaty }} <br />
                                Paliwo: {{ 0 }}
                              </h6>
                              <h6 class="mb-0 counter">
                                Data dodania:
                                {{ new Date(form.published_at).getDate() }}.{{
                                  new Date(form.published_at).getMonth() + 1
                                }}.{{
                                  new Date(form.published_at).getFullYear()
                                }}
                              </h6>
                              <feather type="pocket" class="icon-bg"></feather>
                            </div>
                          </div>
                        </div>
                      </px-card>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Partner system">
                  <div class="row"></div>
                </b-tab>
                <b-tab title="Solo system">
                  <div class="row">
                    <div class="col-sm-6" @click="changeView(form.id)"></div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      months: [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Październik",
        "Listopad",
        "Grudzień",
      ],
      selected: null,
    };
  },
  computed: {
    listItems() {
      return !this.isLoading && this.$store.getters["shifts/monthSalaries"];
    },
  },
  methods: {
    changeView(id) {
      this.$router.push(`/salaries/${id}`);
    },
    async getNewSalaries() {
      this.isLoading = true;
      await this.$store.dispatch("shifts/getSalariesMonth", {month: this.selected});
      this.isLoading = false;
    },
    changeMonth() {
      this.getNewSalaries()
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
  width: 100%;
}
.month {
  width: 33%;
}
</style>
